import React from "react";

export default function About({ t }) {

  return (
    <section className="  my-5 py-5">
      <div className="container  my-5">
        <div className="row align-items-center g-4">
          <div className="col-lg-6">
            <h1 className="fw-bold">{t("about")}</h1>
            <p className="text-secondary">{t("description")}</p>
            <ul className="list-unstyled text-secondary">
              {t("features").map((f, idx) => (
                <li key={idx} className="mb-2">
                  <i className="bi bi-check2-circle me-2"></i>
                  {f}
                </li>
              ))}
            </ul>
          </div>
          <div className="col-lg-6">
            <img
              className="img-fluid rounded shadow"
              src="https://images.unsplash.com/photo-1556740738-b6a63e27c4df?w=1200&q=80"
              alt={t("about")}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
